export const apiURLBase = 'https://archive-api.open-meteo.com/v1/archive';
export const localServerURL = 'http://localhost:8000/create-entry/';
export const stagingServerURL = 'https://api.kxmercury.com/create-entry/';